export class WawiListElement {
    constructor(
        public id: number,
        public key: string,
        public value: string
    ) {
    }
}